<template>
    <div class="c-app-content">
        <div class="c-app-title">
            <div>
                <h1>
                    <img class="c-app-title__icon" src="../../assets/images/icons/icon24-opportunities-primary.svg" alt="opportunities">{{ $t('report') }}
                </h1>
                <p class="c-app-title__back"><router-link to="/report"><i class="fa fa-long-arrow-left"></i>{{ $t('summary') }}</router-link></p>
            </div>
            <ul class="c-app-breadcrumb breadcrumb">
                <li class="breadcrumb-item"><router-link to="/">Callio</router-link></li>
                <li class="breadcrumb-item"><router-link to="/report">{{ $t('reports') }}</router-link></li>
                <li class="breadcrumb-item active">{{ $t('calls') }}</li>
            </ul>
        </div>
        <div class="tile">
            <div class="c-action">
                <div class="row">
                    <div class="col-lg-2 c-action__left"><span class="c-action__title">{{ $t('callReport') }}</span></div>
                    <div class="col-lg-10 c-action__right">
                        <dropdown :model="filterFormModel" attribute="direction" :label="$t('callDirection')" :right-menu="true"
                            type="bordered" icon="fa fa-filter" :options="[
                            {value: null,text:$t('all')},
                            {value:'inbound',text:$t('inbound')},
                            {value:'outbound',text:$t('outbound')},
                            {value:'local',text:$t('local')},
                            ]"
                            @change="load">
                        </dropdown>
                        <dropdown :model="filterFormModel" attribute="group" :right-menu="true"
                            type="bordered" icon="fa fa-list" :options=groupOptions
                            @change="load">
                        </dropdown>
                        <user-group-select v-if="this.$store.state.user.permissions.find(p => p === 'reportListAll' || p === 'reportListGroup')"
                            :model="filterFormModel" attribute="groupUser" is-filter @change="load" :ids="groupIds"></user-group-select>
                        <user-select v-if="this.$store.state.user.permissions.find(p => p === 'reportListAll' || p === 'reportListGroup')"
                            :model="filterFormModel" attribute="user" :group-filter="filterFormModel.groupUser" :groups-filter="groupIds"
                                     :place-holder="$t('selectUser')"></user-select>
                        <time-range-picker type="datetime" :model="filterFormModel" @change="load" :label="$t('time')" :defaultShortcut="3"></time-range-picker>
                        <button class="btn btn-sm btn-primary" @click="load"><i class="fa fa-refresh mr-0"></i></button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-10 c-action__left"></div>
                    <div class="col-lg-2 c-action__right">
                        <call-export :data="data" :filter="filterFormModel"></call-export>
                    </div>
                </div>
            </div>
        <div class="col" v-if="loading">
            <skeleton-loading>
                <row>
                    <square-skeleton :boxProperties="{bottom: '10px', height: '30px'}"></square-skeleton>
                </row>
                <row>
                    <square-skeleton :boxProperties="{bottom: '10px', height: '200px'}"></square-skeleton>
                </row>
            </skeleton-loading>
        </div>
        <div v-else class="tile-body">
            <div class="tile shadow c-report-total">
                <div class="tile-body">
                    <div class="row">
                        <div class="col-sm-6 col-lg-3 text-center">
                            <p class="mb-1">{{ $t('totalCalls') }}</p>
                            <h2 class="mb-3 mb-lg-0">{{ sum.total }}</h2>
                        </div>
                        <div class="col-sm-6 col-lg-3 text-center">
                            <p class="mb-1">{{ $t('totalMinutes') }}</p>
                            <h2 class="mb-3 mb-lg-0">{{ sum.duration | callDuration }}</h2>
                        </div>
                        <div class="col-sm-6 col-lg-3 text-center">
                            <p class="mb-1">{{ $t('connectedSuccessfully') }}</p>
                            <h2 class="mb-3 mb-lg-0">{{ sum.success }}</h2>
                        </div>
                        <div class="col-sm-6 col-lg-3 text-center">
                            <p class="mb-1">{{ $t('talkingTime') }}</p>
                            <h2 class="mb-3 mb-lg-0">{{ sum.billDuration | callDuration }}</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-md-6">
                    <div class="tile shadow">
                        <h3 class="tile-title">{{ $t('calls') }}</h3>
                        <apexchart :height="300" :options="chartOptions" :series="callChartData"></apexchart>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="tile shadow">
                        <h3 class="tile-title">{{ $t('duration') }}</h3>
                        <apexchart :height="300" :options="chartOptions" :series="durationChartData"></apexchart>
                    </div>
                </div>
            </div>
            <div class="table-responsive c-template-table">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th></th>
                            <th></th>
                            <th class="text-center">{{ $t('totalCount') }}</th>
                            <th class="text-center">{{ $t('successCount') }}</th>
                            <th class="text-center">{{ $t('busyCount') }}</th>
                            <th class="text-center">{{ $t('rejectedCount') }}</th>
                            <th class="text-center">{{ $t('invalidNumberCount') }}</th>
                            <th class="text-center">{{ $t('networkBusyCount') }}</th>
                            <th class="text-center">{{ $t('agentNetworkFailCount') }}</th>
                            <th class="text-center">{{ $t('othersCount') }}</th>
                            <th class="text-center">{{ $t('missCall') }}</th>
                            <th class="text-center">{{ $t('talkingTime') }}</th>
                            <th class="text-center">{{ $t('waitingTime') }}</th>
                            <th class="text-center">{{ $t('averageCallTime') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="bg-green-light">
                            <td></td>
                            <td><b class="text-uppercase">{{ $t('totals') }}</b></td>
                            <td class="text-center"><span class="text-blue">{{ sum.total }}</span></td>
                            <td class="text-center"><span class="text-blue">{{ sum.success }}</span></td>
                            <td class="text-center"><span class="text-blue">{{ sum.busy }}</span></td>
                            <td class="text-center"><span class="text-blue">{{ sum.rejected }}</span></td>
                            <td class="text-center"><span class="text-blue">{{ sum.invalidNumber }}</span></td>
                            <td class="text-center"><span class="text-blue">{{ sum.networkBusy }}</span></td>
                            <td class="text-center"><span class="text-blue">{{ sum.agentNetworkFail }}</span></td>
                            <td class="text-center"><span class="text-blue">{{ sum.other }}</span></td>
                            <td class="text-center"><span class="text-blue">{{ sum.missCall }}</span></td>
                            <td class="text-center">{{ sum.billDuration | callDuration }}</td>
                            <td class="text-center">{{ sum.duration - sum.billDuration | callDuration }}</td>
                            <td class="text-center">{{ Math.round(sum.billDuration/sum.success) | callDuration }}</td>
                        </tr>
                        <tr class="bg-yellow-light">
                          <td></td>
                            <td><b class="text-uppercase">{{ $t('average') }}</b></td>
                            <td class="text-center"><span class="text-blue">{{ avg.total }}</span></td>
                            <td class="text-center"><span class="text-blue">{{ avg.success }}</span></td>
                            <td class="text-center"><span class="text-blue">{{ avg.busy }}</span></td>
                            <td class="text-center"><span class="text-blue">{{ avg.rejected }}</span></td>
                            <td class="text-center"><span class="text-blue">{{ avg.invalidNumber }}</span></td>
                            <td class="text-center"><span class="text-blue">{{ avg.networkBusy }}</span></td>
                            <td class="text-center"><span class="text-blue">{{ avg.agentNetworkFail }}</span></td>
                            <td class="text-center"><span class="text-blue">{{ avg.other }}</span></td>
                            <td class="text-center"><span class="text-blue">{{ avg.missCall }}</span></td>
                            <td class="text-center">{{ avg.billDuration | callDuration }}</td>
                            <td class="text-center">{{ avg.duration - avg.billDuration | callDuration }}</td>
                            <td class="text-center">{{ Math.round(avg.billDuration/avg.success) | callDuration }}</td>
                        </tr>
                        <tr :key="index" v-for="(item, index) in data">
                            <td class="text-center">{{index+1}}</td>
                            <td style="min-width: 200px"><b>{{ label(item) }}</b></td>
                            <td class="text-center"><span class="text-blue">{{ item.total }}</span></td>
                            <td class="text-center"><span class="text-blue">{{ item.success }}</span></td>
                            <td class="text-center"><span class="text-blue">{{ item.busy }}</span></td>
                            <td class="text-center"><span class="text-blue">{{ item.rejected }}</span></td>
                            <td class="text-center"><span class="text-blue">{{ item.invalidNumber }}</span></td>
                            <td class="text-center"><span class="text-blue">{{ item.networkBusy }}</span></td>
                            <td class="text-center"><span class="text-blue">{{ item.agentNetworkFail }}</span></td>
                            <td class="text-center"><span class="text-blue">{{ item.other }}</span></td>
                            <td class="text-center"><span class="text-blue">{{ item.missCall }}</span></td>
                            <td class="text-center">{{ item.billDuration | callDuration }}</td>
                            <td class="text-center">{{ item.duration - item.billDuration | callDuration }}</td>
                            <td class="text-center">{{ item.success > 0 ? Math.round((item.billDuration/item.success)) : 0 | callDuration }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    import moment from 'moment';
    import TimeRangePicker from "../../components/TimeRangePicker";
    import Dropdown from "@/components/Dropdown";
    import VueApexCharts from 'vue-apexcharts';
    import UserGroupSelect from "@/components/UserGroupSelect";
    import UserSelect from "@/components/UserSelect";
    import CallExport from "./CallExport";
    export default {
        components: {
            UserGroupSelect, UserSelect,
            Dropdown,
            TimeRangePicker,
            'apexchart': VueApexCharts,
            CallExport
        },
        data() {
            return {
                filterFormModel: {
                    group: 'day',
                    direction: null,
                    groupUser: null,
                    user: null
                },
                loading: true,
                data: [],
                sum: {},
                avg: {},
                chartOptions: {},
                callChartData: [],
                durationChartData: [],
                groupOptions: [
                    {value: 'day', text: this.$t('byDays')},
                    {value: 'user', text: this.$t('byStaffs')},
                    {value: 'group', text: this.$t('byGroups')},
                    {value: 'number', text: this.$t('byNumbers')}
                ]
            }
        },
        methods: {
            load() {
                this.loading = true;
                this.filterFormModel.to = moment(this.filterFormModel.to, 'x').endOf('day').format('x');
                this.$service.get('/report/call', {
                    params: this.filterFormModel
                }).then(response => {
                    this.data = response.data;
                    this.sum = {};
                    this.avg = {};
                    this.data.forEach(item => {
                        item.other = item.total - (item.success + item.busy + item.rejected + item.invalidNumber + item.networkBusy + item.agentNetworkFail);
                        for (let key in item) {
                            if (!this.sum[key]) {
                                this.sum[key] = 0;
                            }
                            this.sum[key] += item[key];
                        }
                    });
                    for (let key in this.sum) {
                        this.avg[key] = Math.round(this.sum[key] / this.data.length);
                    }
                    this.chartOptions = {
                        xaxis: {
                            categories: this.data.map(d => this.label(d)).slice(0, 99).reverse(),
                            labels: {
                                rotate: 0
                            },
                            tooltip: {
                                enabled: false,
                            }
                        },
                        chart: {
                            zoom: {
                                enabled: false
                            },
                            type: this.filterFormModel.group === 'day' ? 'line' : 'bar'
                        }
                    };
                    this.callChartData = [
                        {
                            name: this.$t('totalCount'),
                            data: this.data.map(d => d.total).slice(0, 99).reverse(),
                        },
                        {
                            name: this.$t('successCount'),
                            data: this.data.map(d => d.success).slice(0, 99).reverse(),
                        },
                        {
                            name: this.$t('failureCount'),
                            data: this.data.map(d => d.total - d.success).slice(0, 99).reverse(),
                        },
                        {
                          name: this.$t('missCount'),
                          data: this.data.map(d => d.missCall).slice(0, 99).reverse(),
                        },
                    ];
                    this.durationChartData = [
                        {
                            name: this.$t('duration'),
                            data: this.data.map(d => Math.round(d.duration)).slice(0, 99).reverse(),
                        },
                        {
                            name: this.$t('talkingTime'),
                            data: this.data.map(d => Math.round(d.billDuration)).slice(0, 99).reverse(),
                        },
                        {
                            name: this.$t('waitingTime'),
                            data: this.data.map(d => Math.round(d.duration - d.billDuration)).slice(0, 99).reverse(),
                        },
                    ];
                }).finally(() => {
                    this.loading = false;
                });
            },
            label(item) {
                if (item.label) {
                    return item.label;
                }
                if (!isNaN(item._id)) {
                    return moment(this.filterFormModel.from + item._id, 'x').format('DD/MM/YYYY');
                }
            }
        },
        computed: {
          groupIds() {
            if (this.$store.state.user.permissions.includes('reportListGroup') && !this.$store.state.user.permissions.includes('reportListAll')) {
              return this.$store.state.user.roleGroups
            }
            return null
          }
        }
    };
</script>